module.exports = __webpack_public_path__ + "img/tour-27.328e9190.png";